import { render, staticRenderFns } from "./SeriesDetail.vue?vue&type=template&id=2f891820&"
import script from "./SeriesDetail.vue?vue&type=script&lang=js&"
export * from "./SeriesDetail.vue?vue&type=script&lang=js&"
import style0 from "./SeriesDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports